import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// guards
import AuthGuard from '../guards/AuthGuard';
// layouts
import DashboardLayout from '../layouts/dashboard';
//
import { PATH_CLIENT } from './paths';

// ----------------------------------------------------------------------

const ClientRoutes = {
  path: PATH_CLIENT.root,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: PATH_CLIENT.integration.map_detail_point,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/EndpointDetailMapping'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.callcadence_detail_point,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/CallcadenceDetailMapping'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.duplicate_detail_point,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/DuplicatedDetailMapping'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.override_detail_point,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/OverrideDetailMapping'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.endpontSetting,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/EndpointSetting'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.cpi_detail_point,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/CPIDetailMapping'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.said_detail_point,
      component: lazy(() => import('../views/configure/subaccount/endpoint/versions/SaidDetailMapping'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.list,
      component: lazy(() => import('../views/configure/client/ClientBoard'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.detail,
      component: lazy(() => import('../views/configure/client/DetailClient'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.accounts,
      component: lazy(() => import('../views/configure/client/ClientAccount'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.client,
      component: lazy(() => import('../views/configure/client/ClientAccount'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.create,
      component: lazy(() => import('../views/configure/client/CreateClient'))
    },
    {
      exact: true,
      path: PATH_CLIENT.integration.cadence_detail,
      component: lazy(() => import('../views/configure/subaccount/cadence/CadenceDetail'))
    },
    // ----------------------------------------------------------------------

    {
      component: () => <Redirect to="/404" />
    }    
  ]
};

export default ClientRoutes;
